import type { PropsWithChildren } from 'react';

import OfferBannerProvider from '@/components/app/layout/OfferBannerProvider';
import PageViewedLogger from '@/components/app/layout/PageViewedLogger';
import PrivacyProvider from '@/components/app/layout/PrivacyProvider';
import AuthPromptProvider, { type AuthPrompt } from '@/context/auth/AuthPromptProvider';
import IsAuthenticatingProvider from '@/context/auth/IsAuthenticatingProvider';
import PageNameProvider from '@/context/PageNameProvider';

export type ClientProvidersProps = {
	amplitudeToken?: string;
	analyticsPageName?: string;
	defaultAuthPrompt?: AuthPrompt;
	hideAcceptCookiesModal?: boolean;
};

export default function ClientProviders({
	amplitudeToken,
	analyticsPageName,
	children,
	defaultAuthPrompt,
	hideAcceptCookiesModal,
}: PropsWithChildren<ClientProvidersProps>) {
	return (
		<PageNameProvider pageName={analyticsPageName}>
			<PageViewedLogger />
			<IsAuthenticatingProvider>
				<AuthPromptProvider defaultAuthPrompt={defaultAuthPrompt}>
					<PrivacyProvider amplitudeToken={amplitudeToken} hideAcceptCookiesModal={hideAcceptCookiesModal}>
						<OfferBannerProvider>{children}</OfferBannerProvider>
					</PrivacyProvider>
				</AuthPromptProvider>
			</IsAuthenticatingProvider>
		</PageNameProvider>
	);
}
